import axios from 'axios'
import axiosInstance from '@/plugins/axios'
import {getItem} from '@/helpers/persistantStorage'
import router from '@/router'

const setup = (store) => {
  // Создаем контроллер для отмены запросов
  const CancelToken = axios.CancelToken

  axiosInstance.interceptors.request.use(
    (config) => {
      const token = getItem('nt_token')
      if (token) {
        config.headers['Authorization'] = token
      }

      // Добавляем возможность отмены запроса для каждого запроса
      config.cancelToken =
        config.cancelToken ||
        new CancelToken((cancel) => {
          // Сохраняем функцию отмены в store или другом месте, если нужно
          if (config.saveCancelToken) {
            console.error('CancelToken', {id: config.url, cancelFn: cancel})
          }
        })

      return config
    },
    (error) => Promise.reject(error),
  )

  const refreshAndRetryQueue = []
  let isRefreshing = false

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config

      // ОБРАБОТКА 502
      if (error.response && error.response.status === 502) {
        await store.dispatch('auth/LOGOUT')
        router.push({name: 'Login'})
        return Promise.reject(error)
      }

      //  ОБРАБОТКА 401
      if (error.response && error.response.status === 401) {
        if (!isRefreshing) {
          isRefreshing = true
          try {
            const newAccessToken = await store.dispatch('auth/REFRESH_TOKEN')

            error.config.headers['Authorization'] = `${newAccessToken}`

            // Повторить все запросы в очереди с новым токеном
            refreshAndRetryQueue.forEach(({config, resolve, reject}) => {
              axiosInstance
                .request(config)
                .then((response) => resolve(response))
                .catch((err) => reject(err))
            })

            // Очистить очередь
            refreshAndRetryQueue.length = 0

            // Повторить исходный запрос
            return axiosInstance(originalRequest)
          } catch (refreshError) {
            // Можно очистить всё хранилище и перенаправить пользователя на страницу логина
            return Promise.reject(refreshError)
          } finally {
            isRefreshing = false
          }
        }

        // Добавить исходный запрос в очередь
        return new Promise((resolve, reject) => {
          refreshAndRetryQueue.push({config: originalRequest, resolve, reject})
        })
      }

      return Promise.reject(error)
    },
  )
}

export default setup
